import { INVENTORYANDSALES_URL } from "utils/constants";
import { ENDPOINTS, ENDPOINTSINVENTORYANDSALES } from "utils/endpoints";
import { http } from "utils/http";
    export const getWarehouseIoNo = (docsClassificationId,warehouseId,warehouseIOType,id=null) =>
      http({
        baseURL: INVENTORYANDSALES_URL,
        url: ENDPOINTSINVENTORYANDSALES.Inventory.WarehouseIOApis.InventoryRemittance.nextNo,
        method: "get",
        headers: { "Accept-Language": "en" },
        params:{
          docsClassificationId,
          id,
          warehouseId,
          warehouseIOType
        }
      })
        .then((res) => {
          return res.data;
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    
        export const getSources = (
          pageNumber = 1,
          pageSize = 10,
          searchString = null,
          warehouseId
        ) =>
          http({
            baseURL: INVENTORYANDSALES_URL,
            url: ENDPOINTSINVENTORYANDSALES.Inventory.WarehouseIOApis.InventoryRemittance.browse,
            method: "get",
            params: {
              PageNumber: pageNumber,
              PageSize: pageSize,
              SearchString: searchString,
              warehouseId
            },
          })
            .then((res) => {
              return res.data;
            })
            .catch((err) => {
              return Promise.reject(err);
            });
        export const GenerateFromSource = (SourceId, SourceData) =>
          http({
            baseURL: INVENTORYANDSALES_URL,
            url: ENDPOINTSINVENTORYANDSALES.Inventory.WarehouseIOApis.ReturnReceipt.generate,
            method: "get",
            params: {
              SourceData,
              SourceId,
            },
          })
            .then((res) => {
              return res.data;
            })
            .catch((err) => {
              return Promise.reject(err);
            });
 

        
        
     